import React from 'react';

const Grid = ({ children, className }) => (
  <div className={`grid grid-cols-12 ${className}`}>{children}</div>
)

export default Grid